export const config = {
  buildVersion: import.meta.env.VITE_APP_VERSION || "local",
};
